import { render } from "./EditAddress.vue?vue&type=template&id=1d626a76&scoped=true"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"

import "./EditAddress.vue?vue&type=style&index=0&id=1d626a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d626a76"]])

export default __exports__